import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSelector } from "react-redux";
import classes from "./ModalGlobal.module.scss";
import { useTranslation } from "react-i18next";
import ReactHtmlParser from "html-react-parser";

import RoundedButton from "../Buttons/RoundedButton";
import Spinner from "../../components/UI/Spinner";
import { setAnalyticsCloseModalGlobal } from "../../helpers/analyticsHelpers";

import {
  Modal,
  Card,
  Zoom,
  Fade,
  CardHeader,
  CardActions,
  CardContent,
  CardMedia,
  Slide,
  Box,
  Divider
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import closeIcon from "../../assets/images/icons/SVG/iconXmarkLight.svg";
import defaultImage from "../../assets/images/gif_modal_troca.gif";
import errorImage from "../../assets/images/Afinandinho_surprised.svg";
import { keyframes } from "@mui/system";
import AButton from "../../components/UI/Inputs/MUI/ATextField/AButton";

const defaultCallback = () => {
  console.log("defaultCallback");
};

const rotateBackground = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
//exemplo modalconfigs
// modalConfigs = [
//   {
//     title: "Title",
//     modalStateOpen: true,
//     content:
//       "Lorem ipsum dolor Lorem ipsum <b>dolor</b> Lorem ipsum dolor Lorem ipsum ",
//     media: {
//       image: defaultImage,
//       title: "image",
//     },
//     actions: [
//       { type: "nextModal", text: "next" },
//       { type: "cancel", text: "cancel" },
//     ],
//     scheme: ["header", "content", "media", "actions"],
//   },
//   {
//     title: "Title2",
//     modalStateOpen: true,
//     content:
//       "Lorem ipsum dolor Lorem ipsum <b>dolor</b> Lorem ipsum dolor Lorem ipsum ",
//     media: {
//       image: "",
//       title: "image",
//     },
//     actions: [
//       { type: "nextModal", text: "confirm", callback: defaultCallback },
//       { type: "backModal", text: "back" },
//       { type: "cancel", text: "cancel" },
//     ],
//     scheme: ["content", "header", "actions"],
//   },
//   {
//     title: "Title3",
//     modalStateOpen: true,
//     content:
//       "Lorem ipsum dolor Lorem ipsum <b>dolor</b> Lorem ipsum dolor Lorem ipsum ",
//     media: {
//       image: "",
//       title: "image",
//     },
//     actions: [
//       { type: "custom", text: "confirm", callback: defaultCallback },
//       { type: "backModal", text: "back" },
//       { type: "cancel", text: "cancel" },
//     ],
//     scheme: ["header", "actions", "content"],
//   },
// ],

const ModalGlobal = forwardRef(
  (
    {
      startModal = 0,
      modalConfigs = null,
      errorModalConfig = null,
      openState = null,
      setOpenState = null,
      altActions = null,
      cardStyle = {},
      onCloseModal = null
    },
    ref
  ) => {
    const { t } = useTranslation();
    const [CurrentModal, setCurrentModal] = useState(startModal);
    const [open, setOpen] = useState(false);
    const [canClose, setCanClose] = useState(false);
    const [ButtonType, setButtonType] = useState([]);
    const [ModalScheme, setModalScheme] = useState(null);
    const [ModalMount, setModalMount] = useState(null);
    const [ModalConfig, setModalConfig] = useState(null);
    const { activeUser, session } = useSelector((state) => state.session);
    const [loadingModal, setLoadingModal] = useState({
      title: t("shop.processing_title"),
      modalStateOpen: true,
      content: t("shop.processing"),
      media: {
        image: defaultImage,
        title: "processing",
        class: classes.mediaImageLoad,
      },
      actions: [{ type: "nextModal", text: "next" }],

      scheme: ["header", "media", "content"],
    });

    const [errorModal, setErrorModal] = useState(
      errorModalConfig
        ? errorModalConfig
        : {
          title: t("shop.processing_error_title"),
          modalStateOpen: true,
          content: t("shop.processing_error"),
          media: {
            image: errorImage,
            title: "error",
            class: classes.mediaImageLoad,
          },
          actions: [{ type: "nextModal", text: "next" }],

          scheme: ["header", "media", "content"],
        }
    );

    const handleClose = () => {
      setOpenState(false);
      setOpen(false);
      setCurrentModal(startModal);
      setCanClose(false);
      setAnalyticsCloseModalGlobal({
        target: "close modal:" + ModalConfig?.title,
      });
      if (onCloseModal) {
        onCloseModal()
      }
    };

    useEffect(() => {
      if (open) {
        console.log("isopen ****: ", open);
        setCanClose(true);
      }
    }, [open]);

    // useEffect(() => {
    //   if (session && canClose && open == false) {
    //     console.log("************");
    //     console.log("session: ", session);
    //     console.log("canClose: ", canClose);
    //     console.log("open: ", open);
    //     setAnalyticsCloseModalGlobal({
    //       target: "close modal:" + ModalConfig?.title,
    //     });
    //   }
    // }, [canClose, open, session]);

    // useEffect(() => {
    //   setCurrentModal(startModal);

    // }, [modalConfigs]);

    useEffect(() => {
      if (modalConfigs != null) {
        setModalConfig(modalConfigs[CurrentModal]);
      } else {
        // console.log("setMODAL 0");
        setCurrentModal(0);
      }
    }, [CurrentModal, modalConfigs]);

    useEffect(() => {
      // console.log("first openState: ", openState);
      if (openState && ModalConfig) {
        // console.log("ModalConfig.modalStateOpen: ", ModalConfig.modalStateOpen);
        setOpen(ModalConfig.modalStateOpen);
      }
    }, [ModalConfig, openState]);

    // useEffect(() => {
    //   if (openState !== open) {
    //     setOpen(openState);
    //   }
    // }, [openState]);

    useEffect(() => {
      if (openState) {
        setCurrentModal(startModal);
      }
      if (openState !== open) {
        setOpen(openState);
      }
    }, [openState]);

    //botões
    useEffect(() => {
      if (ModalConfig) {
        const buttonScheme = (button, index) => {
          switch (button.type) {
            case "custom":
              return (
                <AButton
                  key={index}
                  className={button?.style ? classes[button.style] : ""}
                  onClick={button.callback}
                  startIcon={button.icon && button.iconPosition !== "end" ? button.icon : null}
                  endIcon={button.icon && button.iconPosition === "end" ? button.icon : null}
                  variant={button.variant ? button.variant : "contained"}
                  color={button.color ? button.color : "primary"}
                  sx={button?.sx ? { ...button.sx } : { width: "100%" }}
                  disabled={button.disabled}
                >
                  {t(button.text)}
                </AButton>
              );
            case "cancel":
              return (
                <AButton
                  key={index}
                  variant="outlined"
                  sx={button?.sx ? { ...button.sx } : { width: "100%" }}
                  className={
                    button?.style
                      ? classes[button.style]
                      : classes.buttonOutline
                  }
                  onClick={() => handleClose()}
                >
                  {t(button.text)}
                </AButton>
              );
            case "nextModal":
              return (
                <AButton
                  key={index}
                  variant="contained"
                  className={button?.style ? classes[button.style] : ""}
                  width="100%"
                  onClick={() =>
                    nextModal(
                      CurrentModal <= modalConfigs.length
                        ? CurrentModal + 1
                        : CurrentModal
                    )
                  }
                >
                  {t(button.text)}
                </AButton>
              );
            case "backModal":
              return (
                <AButton
                  key={index}
                  className={button?.style ? classes[button.style] : ""}
                  onClick={() =>
                    nextModal(
                      CurrentModal > 0 ? CurrentModal - 1 : CurrentModal
                    )
                  }
                >
                  {t(button.text)}
                </AButton>
              );
          }
        };
        const newButtonScheme = ModalConfig.actions?.map((item, index) =>
          buttonScheme(item, index)
        );

        setButtonType(newButtonScheme);
      }
    }, [ModalConfig, CurrentModal]);

    //estrutura interna
    useEffect(() => {
      if (ModalConfig) {
        const mountScheme = (schemeItem, index) => {
          switch (schemeItem) {
            case "header":
              return ModalConfig.header ? (
                <CardHeader key={`modal-header-${index}`} {...ModalConfig.header} />
              ) : (
                <CardHeader key={`modal-header-${index}`}
                  className={
                    ModalConfig.title == ""
                      ? classes.modalTitleEmpty
                      : classes.modalTitle
                  }
                  title={ModalConfig.title}
                  subheader={ModalConfig.subtitle ? ModalConfig.subtitle : null}
                  titleTypographyProps={{variant:'h5',color:'primary' ,fontWeight: "semibold", sx: ModalConfig.headerSx?.title, }}
                  action={<img onClick={() => handleClose()} src={closeIcon} />}
                />
              );
            case "content":
              return (
                <CardContent key={`modal-content-${index}`} className={classes.modalContent}>
                  {typeof ModalConfig.content === "string"
                    ? ReactHtmlParser(ModalConfig.content)
                    : ModalConfig.content}
                </CardContent>
              );
            case "content2":
              return (
                <CardContent key={`modal-content2-${index}`} className={classes.modalContent}>
                  {typeof ModalConfig.content === "string"
                    ? ReactHtmlParser(ModalConfig.content2)
                    : ModalConfig.content}
                </CardContent>
              );
            case "media":
              return (
                <CardMedia key={`modal-media-${index}`}
                  image={ModalConfig.media.image}
                  title={ModalConfig.media.title}
                  sx={{
                    height: "auto",
                    minHeight: ModalConfig.media.size
                      ? ModalConfig.media.size
                      : "180px",
                    backgroundSize: "contain",
                    animation: ModalConfig.media.rotate
                      ? `${rotateBackground} 3s linear infinite`
                      : "none",
                  }}
                  className={
                    ModalConfig.media.class ? ModalConfig.media.class : ""
                  }
                />
              );
            case "actions":
              return (
                <CardActions key={`modal-actions-${index}`}
                  sx={{
                    ...ModalConfig.actionsSx,
                    "& > :not(style) ~ :not(style)": {
                      marginLeft: 0,
                    },
                  }}
                  className={altActions ? altActions : classes.modalActions}
                >
                  {ButtonType}
                </CardActions>
              );
            case "customActions":
              return (
                <CardActions key={`modal-custom-actions-${index}`}
                  sx={{
                    ...ModalConfig.customActions.sx,
                  }}
                >
                  <Grid container spacing={2} sx={{ display: "flex", justifyContent: "center", width: "100%", m: 2 }}>
                    {ButtonType?.map((button, index) => {
                      return (
                        <Grid item size={{ xs: 12, sm: 6 }} sx={{ display: "flex", justifyContent: "center" }} key={`customActions${index}`}>
                          {button}
                        </Grid>
                      );
                    })}
                  </Grid>
                </CardActions>
              );
            case "customComponent":
              return <div key={`modal-custom-component-${index}`}>{ModalConfig.customComponent}</div>;
            case "customComponent2":
              return <div key={`modal-custom-component-2-${index}`}>{ModalConfig.customComponent2}</div>;
            case "divider":
              return <Divider key={`modal-divider-${index}`} />;
          }
        };
        const newModalScheme = ModalConfig.scheme.map((schemeItem, index) =>
          mountScheme(schemeItem, index)
        );
        setModalScheme(newModalScheme);
      }
    }, [ModalConfig, ButtonType, CurrentModal]);


    useEffect(() => {
      if (ModalConfig) {
        setModalMount(
          <Fade
            direction="up"
            in={open}
            style={{ transitionDelay: open ? "200ms" : "0ms" }}
          >
            <div>
              <Modal
                open={!!open}
                onClose={() => handleClose()}
                disableScrollLock
                {...(ModalConfig.extraConfigs ? ModalConfig.extraConfigs : {})}
                  
                
              >
                <Box
                  className={
                    ModalConfig?.size
                      ? classes["modal" + ModalConfig?.size]
                      : classes.modal
                  }
                  key={CurrentModal}
                >
                  <Zoom
                    in={open}
                    style={{ transitionDelay: open ? "200ms" : "0ms" }}
                  >
                    <Card
                      sx={{
                        height: "auto",
                        borderRadius: "10px",
                        ...ModalConfig?.cardStyle, //Aceita estilização personalizada para o card
                      }}
                    >
                      {ModalScheme}
                    </Card>
                  </Zoom>
                </Box>
              </Modal>
            </div>
          </Fade>
        );
      }
    }, [open, ModalScheme, CurrentModal, ButtonType, ModalConfig]);

    const nextModal = (next) => {
      setCurrentModal(next);
    };

    const loading = (configs = null) => {
      setModalConfig({ ...loadingModal, ...configs });
    };

    const customLoading = (customLoading, configs = null) => {
      setModalConfig({ ...customLoading, ...configs });
    };

    const error = () => {
      setModalConfig(errorModal);
    };

    useImperativeHandle(ref, () => ({
      nextModal,
      loading,
      customLoading,
      error,
    }));
    return ModalMount;
  }
);

export default ModalGlobal;
